import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonColors, ButtonSizes, PrimaryButton } from 'src/shared/design-system/Buttons';
import { ShareArrow } from 'src/shared/design-system/Icon';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import styled from 'styled-components';
import { ScreenWidth, Spacing } from 'web-common/src/shared/styles';

const Share = styled(ShareArrow)`
  width: 16px;
  margin-right: 6px;
`;

const Button = styled(PrimaryButton)`
  position: relative;
  padding: 0 ${Spacing.SINGLE_QUARTER} 0 ${Spacing.SINGLE};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: 0 6px 0 12px;
    > span {
      display: none;
    }
  }
`;

interface ReferShefButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  shefId: string;
}

export const ReferShefButton = ({ shefId, ...props }: ReferShefButtonProps) => {
  const path = getSluggedPath(Routes.CONSUMER_ACCOUNT_SHARE_SHEF, [{ slug: Slugs.SHEF_ID, value: shefId }]);

  return (
    <Link to={path}>
      <Button {...props} color={ButtonColors.LIGHT_GRAY} size={ButtonSizes.M}>
        <Share />
        <span>Share</span>
      </Button>
    </Link>
  );
};
